import { SchemaModifier } from '../types';
import { normalizeContent } from '@fhnw/helpers/DesignSystem/normalizeContent';

const degreeProgramModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  if (content?.degree_program_type) {
    main['programType'] = normalizeContent(content?.degree_program_type, true);
  }
};

export default degreeProgramModifier;
